import * as React from "react";
import {
  Box,
  Popover,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CheckboxList from "../common/CheckboxList";

const ReportAdvanceFilters = ({
  anchorEl,
  setAnchorEl,
  organizationOptions,
  selectedOrganizations,
  setSelectedOrganizations,
  disabled,
}) => {
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const [organizationsExpanded, setOrganizationsExpanded] =
    React.useState(true);

  const clearAllFilters = () => {
    setSelectedOrganizations([]);
    handleClose();
  };

  return (
    <Popover
      id="report-filters"
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="popover-filter-container">
        <div className="header-wrapper">
          <div className="header">Filters</div>
          {selectedOrganizations.length > 0 && (
            <button onClick={clearAllFilters} className="clear-all">
              <svg
                width="9"
                height="9"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  y="7.99902"
                  width="8"
                  height="8"
                  rx="1"
                  transform="rotate(-90 0 7.99902)"
                  fill="#FF890A"
                />
                <path
                  d="M2.13699 1.66585L1.66699 2.13585L3.53033 3.99919L1.66699 5.86252L2.13699 6.33252L4.00033 4.46919L5.86366 6.33252L6.33366 5.86252L4.47033 3.99919L6.33366 2.13585L5.86366 1.66585L4.00033 3.52919L2.13699 1.66585Z"
                  fill="white"
                />
              </svg>
              <span>Clear All</span>
            </button>
          )}
        </div>

        <p className="tag-number">
          {organizationOptions?.length} existing organizations tags
        </p>

        <Accordion
          expanded={organizationsExpanded}
          onChange={() => setOrganizationsExpanded(!organizationsExpanded)}
          sx={{
            boxShadow: "none",
            border: "none",
            marginTop: "12px",
            "&.Mui-expanded": {
              marginTop: "12px",
            },
            "&:before": {
              display: "none",
            },
          }}
        >
          <AccordionSummary
            expandIcon={null}
            sx={{
              padding: 0,
              minHeight: "20px",
              "&.MuiAccordionSummary-root": {
                minHeight: "20px",
              },
              "&.MuiAccordionSummary-gutters": {
                padding: 0,
                minHeight: "20px",
              },
              "&.Mui-expanded": {
                minHeight: "20px",
              },
              "& .MuiAccordionSummary-content": {
                margin: 0,
                alignItems: "center",
                minHeight: "20px",
              },
              "& .MuiAccordionSummary-contentGutters": {
                marginBottom: "10px",
                minHeight: "20px",
              },
              "& .MuiAccordionSummary-content.Mui-expanded": {
                margin: 0,
                minHeight: "20px",
                alignItems: "center",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                p: "0 20px 0 12px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  transform: organizationsExpanded
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                  transition: "transform 0.2s ease-in-out",
                }}
              >
                <ArrowDropDownIcon />
              </Box>
              <p className="collapse-list-header">Organizations</p>
            </Box>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: 0,
              backgroundColor: "#F8F8F8",
              p: "20px 20px 12px 16px",
            }}
          >
            <CheckboxList
              items={organizationOptions?.map((organization) => ({
                id: organization.id,
                label: <div>{organization.name}</div>,
              }))}
              checkedItems={selectedOrganizations}
              setCheckedItems={setSelectedOrganizations}
              labelField="label"
              disabled={disabled}
            />
          </AccordionDetails>
        </Accordion>
      </div>
    </Popover>
  );
};

export default ReportAdvanceFilters;
